
// import { Avatar, Badge, Dropdown, Space } from 'antd';
// import { UserOutlined, LogoutOutlined, ProfileOutlined, MessageOutlined, BellOutlined, SettingOutlined } from '@ant-design/icons';
// import type { MenuProps } from 'antd';
// import type { Settings as LayoutSettings } from "@ant-design/pro-components";
// import { PageLoading, SettingDrawer } from "@ant-design/pro-components";
// import type { RequestConfig, RunTimeLayoutConfig } from "@umijs/max";
// import { history} from "@umijs/max";
// import "@ant-design/v5-patch-for-react-19";
// import defaultSettings from "../config/defaultSettings";
// import { errorConfig } from "./requestErrorConfig";
// import { currentUser } from "./services/eb/api";
// import { 
//   CrownOutlined, 
//   SmileOutlined, 
//   DashboardOutlined, 
//   BankOutlined, 
//   TeamOutlined, 
//   UserSwitchOutlined, 
//   BookOutlined 
// } from '@ant-design/icons';
// import '@/global.less';

// const IconMap = {
//   CrownOutlined: <CrownOutlined />,
//   SmileOutlined: <SmileOutlined />,
//   DashboardOutlined: <DashboardOutlined />,
//   BankOutlined: <BankOutlined />,
//   UserOutlined: <UserOutlined />,
//   TeamOutlined: <TeamOutlined />,
//   UserSwitchOutlined: <UserSwitchOutlined />,
//   BookOutlined: <BookOutlined />,
// };
// const loopMenuItem = (menus: any[]): any[] => {
//   return menus.map(({ icon, children, ...item }) => {
//     const iconComponent = typeof icon === 'string' && IconMap[icon as keyof typeof IconMap] 
//       ? IconMap[icon as keyof typeof IconMap] 
//       : icon;

//     return {
//       ...item,
//       icon: iconComponent,
//       children: children && loopMenuItem(children),
//     };
//   });
// };
// const isDev = process.env.NODE_ENV === "development" || process.env.CI;
// const loginPath = "/user/login";

// /**
//  * Public paths that don't require the user to be logged in.
//  * Add any other public routes here (e.g. marketing pages, docs).
//  */
// const PUBLIC_PATHS = [
//   '/',               
//   loginPath,
//   '/user/register',
//   '/terms',
//   '/terms.html',
//   '/privacy',
//   '/privacy.html',
//   '/user/home',
// ];


// const isPublicPath = (pathname?: string) => {
//   if (!pathname) return false;
//   return PUBLIC_PATHS.some((p) => pathname === p || pathname.startsWith(p));
// };

// /**
//  * @see https://umijs.org/docs/api/runtime-config#getinitialstate
//  * */
// export async function getInitialState(): Promise<{
//   settings?: Partial<LayoutSettings>;
//   currentUser?: API.CurrentUser | any;
//   loading?: boolean;
//   fetchUserInfo?: () => Promise<API.CurrentUser | undefined | any>;
// }> {
//   const fetchUserInfo = async () => {
//     try {
//       const msg = await currentUser({
//         skipErrorHandler: true,
//       });
//       // console.log(msg)
//       return msg;
//     } catch (_error) {
//       // only redirect to login if current path is NOT public and not under /users/
//       const path = history.location.pathname;
//       if (!isPublicPath(path) && !path.startsWith("/users/")) {
//         history.push(loginPath);
//       }
//     }
//     return undefined;
//   };

//   const { location } = history;
//   if (
//     !isPublicPath(location.pathname) &&
//     !location.pathname.startsWith("/users/")
//   ) {
//     const currentUser = await fetchUserInfo();
//     return {
//       fetchUserInfo,
//       currentUser,
//       settings: defaultSettings as Partial<LayoutSettings>,
//     };
//   }
//   return {
//     fetchUserInfo,
//     settings: defaultSettings as Partial<LayoutSettings>,
//   };
// }

// // ProLayout 支持的api https://procomponents.ant.design/components/layout
// export const layout: RunTimeLayoutConfig = ({ initialState, setInitialState, loading }) => {
//   const userType = initialState?.currentUser?.userType;
//   return {
//    layout: userType === 'STUDENT' ? 'top' : 'side',
//     menu: {
//        locale: false,
//        params: {
//          userId: initialState?.currentUser?.id,
//        },
//     },
//     menuDataRender: (menuData) => loopMenuItem(menuData),
//     token: {
//       sider: {
//         colorMenuBackground: '#fff',       
//         colorTextMenu: '#6B7280',          
//         colorTextMenuSelected: '#0F3659',  
//         colorTextMenuItemHover: '#0F3659',
//         colorBgMenuItemSelected: '#E6F7FF',
//       },
//     },
//   actionsRender: () => [
//       <Badge
//         key="notify"
//         count={2} 
//         size="small"
//         style={{ margin: '0 8px' }} 
//         onClick={() => console.log('Notification clicked')}
//       >
//         <Avatar
//           shape="circle"
//           size="small"
//           style={{
//           backgroundColor: '#FF4B0026', 
//           color: '#FE5C73',  
//             cursor: 'pointer',
//           }}
//           icon={<BellOutlined />}
//         />
//       </Badge>,
//        <Badge
//         key="notify"
//         count={3} 
//         size="small"
//         style={{ margin: '0 8px' }} 
//         onClick={() => console.log('Notification clicked')}
//       >
//        <Avatar
//         key="chat"
//         shape="circle"
//         size="small"
//         style={{
//           backgroundColor: '#2D9CDB26', 
//           color: '#3498DB',          
//           cursor: 'pointer',
//           margin: '0 8px'
//         }}
//         icon={<MessageOutlined />}
//         onClick={() => console.log('Chat clicked')}
//       />
//       </Badge>,
//        <Badge
//         key="notify"
//         count={1} 
//         size="small"
//         style={{ margin: '0 8px' }} 
//         onClick={() => console.log('Notification clicked')}
//       >
//       <Avatar
//         key="settings"
//         shape="circle"
//         size="small"
//         style={{
//           backgroundColor: '#FF4B0026', 
//           color: '#FE5C73',           
//           cursor: 'pointer',
//           margin: '0 8px'
//         }}
//         icon={<SettingOutlined />}
//         onClick={() => console.log('Settings clicked')}
//       />
//       </Badge>,
//     ],
//  avatarProps: {
//   render: (_, dom) => { 
//     const menuItems: MenuProps['items'] = [
//       {
//         key: 'profile',
//         icon: <ProfileOutlined />,
//         label: 'Profile',
//       },
//       {
//         key: 'logout',
//         icon: <LogoutOutlined />,
//         label: 'Log Out',
//       },
//     ];

//     const onMenuClick = (event: { key: string }) => {
//       const { key } = event;
//       if (key === 'logout') {
//         console.log('Logging out...');
//         localStorage.removeItem('your_auth_token_key');
//         history.push(loginPath);
//       } else if (key === 'profile') {
//         history.push('/admindash/profile');
//       }
//     };

//     return (
//       <Dropdown
//         menu={{
//           items: menuItems,
//           onClick: onMenuClick,
//         }}
//       >
//         <Space style={{ cursor: 'pointer' }}>
//           <span style={{ color: '#000', padding: '0 8px' }}>
//             Hello, {initialState?.currentUser?.name || 'User'}
//           </span>
//           {dom} 
//         </Space>
//       </Dropdown>
//     );
//   },
// },
//     waterMarkProps: {
//       content: initialState?.currentUser?.name,
//     },
//   //  footerRender: () => (
//   //     <div style={{ textAlign: 'center', padding: '16px' }}>
//   //       © Powered by Microvision Innovations
//   //     </div>
//   //   ),
// menuFooterRender: (props) => {
//       if (props?.collapsed) return undefined;

//       return (
//         <div
//           style={{
//             textAlign: 'center',
//             padding: '0 0', 
//             transition: 'all 0.3s',
//           }}
//         >
//           <img
//             src="/Frame 1984078497.png" 
//             alt="Adam Molai Foundation"
//             style={{ width: '150px', height: 'auto' }} 
//           />
//         </div>
//       );
//     },
//     onPageChange: () => {
//       // 如果没有登录，重定向到 login — but skip public paths
//       const path = history.location.pathname;
//       if (
//         !initialState?.currentUser &&
//         !isPublicPath(path) &&
//         !path.startsWith("/users/")
//       ) {
//         history.push(loginPath);
//       }
//     },
//     bgLayoutImgList: [
//       {
//         src: "https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/D2LWSqNny4sAAAAAAAAAAAAAFl94AQBr",
//         left: 85,
//         bottom: 100,
//         height: "303px",
//       },
//       {
//         src: "https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/C2TWRpJpiC0AAAAAAAAAAAAAFl94AQBr",
//         bottom: -68,
//         right: -45,
//         height: "303px",
//       },
//       {
//         src: "https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/F6vSTbj8KpYAAAAAAAAAAAAAFl94AQBr",
//         bottom: 0,
//         left: 0,
//         width: "331px",
//       },
//     ],
//     links: [],
//     menuHeaderRender: undefined,
//     // 自定义 403 页面
//     unAccessible: <div>unAccessible</div>,
//     // 增加一个 loading 的状态
//   childrenRender: (children) => {
//    if (loading) return <PageLoading />;
//       return (
//         <>
//           {children}
//           {/* SettingDrawer removed from here to hide the blue settings handle */}
//         </>
//       );
//     },
//     ...initialState?.settings,
    
    
//   };
// };

// /**
//  * @name request 配置，可以配置错误处理
//  * 它基于 axios 和 ahooks 的 useRequest 提供了一套统一的网络请求和错误处理方案。
//  * @doc https://umijs.org/docs/max/request#配置
//  */
// export const request: RequestConfig = {
//   baseURL: API_BASE_URL,
//   ...errorConfig,
// };
import { Avatar, Badge, ConfigProvider, Dropdown, Space } from 'antd';
import { UserOutlined, LogoutOutlined, ProfileOutlined, MessageOutlined, BellOutlined, SettingOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import type { Settings as LayoutSettings } from "@ant-design/pro-components";
import { PageLoading } from "@ant-design/pro-components";
import type { RequestConfig, RunTimeLayoutConfig } from "@umijs/max";
import { history } from "@umijs/max";
import "@ant-design/v5-patch-for-react-19";
import defaultSettings from "../config/defaultSettings";
import { errorConfig } from "./requestErrorConfig";
import { currentUser } from "./services/eb/api";
import { 
  CrownOutlined, 
  SmileOutlined, 
  DashboardOutlined, 
  BankOutlined, 
  TeamOutlined, 
  UserSwitchOutlined, 
  BookOutlined 
} from '@ant-design/icons';
import '@/global.less';
import enUS from 'antd/es/locale/en_US';


const IconMap = {
  CrownOutlined: <CrownOutlined />,
  SmileOutlined: <SmileOutlined />,
  DashboardOutlined: <DashboardOutlined />,
  BankOutlined: <BankOutlined />,
  UserOutlined: <UserOutlined />,
  TeamOutlined: <TeamOutlined />,
  UserSwitchOutlined: <UserSwitchOutlined />,
  BookOutlined: <BookOutlined />,
};

const loopMenuItem = (menus: any[]): any[] => {
  return menus.map(({ icon, children, ...item }) => {
    const iconComponent = typeof icon === 'string' && IconMap[icon as keyof typeof IconMap] 
      ? IconMap[icon as keyof typeof IconMap] 
      : icon;

    return {
      ...item,
      icon: iconComponent,
      children: children && loopMenuItem(children),
    };
  });
};

const loginPath = "/user/login";

const PUBLIC_PATHS = [
  '/',               
  loginPath,
  '/user/register',
  '/terms',
  '/terms.html',
  '/privacy',
  '/privacy.html',
  '/user/home',
];

const isPublicPath = (pathname?: string) => {
  if (!pathname) return false;
  return PUBLIC_PATHS.some((p) => pathname === p || pathname.startsWith(p));
};

/**
 * @name getInitialState
 */
export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  currentUser?: any;
  loading?: boolean;
  fetchUserInfo?: () => Promise<any>;
}> {
  const fetchUserInfo = async () => {
    try {
      const msg = await currentUser({ skipErrorHandler: true });
      // 🛠️ Check if your API wraps data in a 'data' property
      return msg?.data || msg; 
    } catch (_error) {
      const path = history.location.pathname;
      if (!isPublicPath(path) && !path.startsWith("/users/")) {
        history.push(loginPath);
      }
    }
    return undefined;
  };

  const { location } = history;
  if (!isPublicPath(location.pathname) && !location.pathname.startsWith("/users/")) {
    const user = await fetchUserInfo();
    return {
      fetchUserInfo,
      currentUser: user,
      settings: defaultSettings as Partial<LayoutSettings>,
    };
  }
  return {
    fetchUserInfo,
    settings: defaultSettings as Partial<LayoutSettings>,
  };
}

/**
 * @name layout
 */
export const layout: RunTimeLayoutConfig = ({ initialState, loading }) => {
  const userType = initialState?.currentUser?.userType;
  
  return {
    layout: userType === 'STUDENT' ? 'top' : 'side',
    menu: {
       locale: false,
       params: { userId: initialState?.currentUser?.id },
    },
    menuDataRender: (menuData) => loopMenuItem(menuData),
    actionsRender: () => [
      <Badge key="notify" count={2} size="small" style={{ margin: '0 8px' }}>
        <Avatar shape="circle" size="small" style={{ backgroundColor: '#FF4B0026', color: '#FE5C73' }} icon={<BellOutlined />} />
      </Badge>,
      <Badge key="chat" count={3} size="small" style={{ margin: '0 8px' }}>
        <Avatar shape="circle" size="small" style={{ backgroundColor: '#2D9CDB26', color: '#3498DB' }} icon={<MessageOutlined />} />
      </Badge>,
      <Badge key="settings" count={1} size="small" style={{ margin: '0 8px' }}>
        <Avatar shape="circle" size="small" style={{ backgroundColor: '#FF4B0026', color: '#FE5C73' }} icon={<SettingOutlined />} />
      </Badge>,
    ],
    avatarProps: {
      render: (_, dom) => { 
        const menuItems: MenuProps['items'] = [
          { key: 'profile', icon: <ProfileOutlined />, label: 'Profile' },
          { key: 'logout', icon: <LogoutOutlined />, label: 'Log Out' },
        ];
        const onMenuClick = (event: { key: string }) => {
          if (event.key === 'logout') {
            localStorage.removeItem('your_auth_token_key');
            history.push(loginPath);
          } else if (event.key === 'profile') {
            history.push('/admindash/profile');
          }
        };
        return (
          <Dropdown menu={{ items: menuItems, onClick: onMenuClick }}>
            <Space style={{ cursor: 'pointer' }}>
              <span style={{ color: '#000', padding: '0 8px' }}>
                Hello, {initialState?.currentUser?.name || 'User'}
              </span>
              {dom} 
            </Space>
          </Dropdown>
        );
      },
    },
    menuFooterRender: (props) => {
      if (props?.collapsed) return undefined;
      return (
        <div style={{ textAlign: 'center', padding: '10px' }}>
          <img src="/Frame 1984078497.png" alt="Logo" style={{ width: '150px', height: 'auto' }} />
        </div>
      );
    },
    onPageChange: () => {
      const path = history.location.pathname;
      if (!initialState?.currentUser && !isPublicPath(path) && !path.startsWith("/users/")) {
        history.push(loginPath);
      }
    },
    childrenRender: (children: any) => {
      if (loading) return <PageLoading />;
     return (
        <ConfigProvider locale={enUS}>
          {children}
        </ConfigProvider>
      );
    },
    ...initialState?.settings,
  };
};

export const request: RequestConfig = {
  baseURL: API_BASE_URL,
  ...errorConfig,
};